<div class="item tw-border tw-border-solid b-{{ getTrendColor(user.trend) }}" [elementDataTest]="user.id">
    <div class="tw-flex tw-items-center tw-justify-between tw-w-full">
        <div class="tw-flex tw-items-center">
            <div
                class="tw-text-center tw-relative tw-inline-flex tw-justify-center tw-items-center tw-rounded-full tw-border tw-border-solid tw-box-content tw-transition-all tw-duration-150 tw-ease-in-out tw-mr-3 tw-font-bold"
                [ngClass]="['b-' + getTrendColor(user.trend), user.rank > 99 ? 'tw-size-8.5' : 'tw-size-6.5']"
            >
                <span [ngClass]="['tw-text-' + getTrendColor(user.trend), user.rank > 99 ? 'tw-font-xs' : 'tw-font-sm']">{{ user.rank }}</span>
            </div>
            <div class="tw-px-0">
                <span class="tw-text-black tw-font-sm tw-font-bold">{{ getUserFullName(user) }}</span>
            </div>
        </div>
        <div class="tw-flex tw-items-center">
            <div>
                <span class="tw-text-black tw-font-xs">{{ 'v3-global-number-pts' | translate: { points: user.points | pts } }}</span>
            </div>
            <div aria-hidden="true" class="tw-ml-2">
                <div [ngSwitch]="user.trend">
                    <div *ngSwitchCase="'success'">
                        <app-icon name="arrow-up" class="tw-fill-success tw-w-4 tw-h-4"></app-icon>
                    </div>
                    <div class="tw-flex tw-items-center" *ngSwitchCase="'muted'">
                        <div class="tw-size-4 tw-border tw-border-black-10 tw-border-solid tw-bg-black-10 tw-rounded-full"></div>
                    </div>
                    <div *ngSwitchCase="'danger'">
                        <app-icon name="arrow-down" class="tw-fill-danger tw-w-4 tw-h-4"></app-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
